import React, {useEffect, useRef, useState} from "react";
import styled from "styled-components";
import {useDispatch, useSelector} from "react-redux";
import {deleteTagCategory, loadAllTagCategories, loadOneTagCategory} from "./tagCategory/tagCategoryAction";
import AddButtonFullText from "../buttons/AddButtonFullText";
import AddTagModal from "../modal/AddTagModal";
import Loader from "../progress-bar/Loader";
import EditButton from "../buttons/EditButton";
import DeleteButton from "../buttons/DeleteButton";
import {deleteTag, loadTag} from "./subTag/tagsAction";
import YesNoModal from "../modal/YesNoModal";
import ToggleTagCard from "./ToggleTagCard";
import {TagCardStyled} from "./TagCard";
import {DisplayForHead} from "../../permissions/DisplayAccordingToRole";


const TagsSectionSetting = () => {

    const dispatch = useDispatch()
    const [categoryId, setCategoryId] = useState(0)
    const [tagId, setTagId] = useState(0)
    const [addModalIsOpen, setAddModalIsOpen] = useState(false)
    const [editModalIsOpen, setEditModalIsOpen] = useState(false)
    const [editTagModalIsOpen, setEditTagModalIsOpen] = useState(false)
    const [deleteTagModalIsOpen, setDeleteTagModalIsOpen] = useState(false)
    const [deleteCategoryModalIsOpen, setDeleteCategoryModalIsOpen] = useState(false)
    const containerRef = useRef()

    const {isLoading, tagCategories: categories} = useSelector(state => state.tagCategories)
    const category = useSelector(state => state.tagCategory)
    const tag = useSelector(state => state.tag)
    const {status: currentUserStatus} = useSelector(state => state.currentUser)


    useEffect(() => {
        if (currentUserStatus === 200) {
            dispatch(loadAllTagCategories())
        }
    }, [currentUserStatus, dispatch])

    const displaySubTag = (id) => {
        if (id !== 0) {
            let categorySelected = categories.filter(c => c.id === id)[0]
            return (
                <ContainerTagList className={"flex-col gap-1 w-100"}>
                    <h2 id={"category-tag-selected"}> {categorySelected.name} </h2>
                    <div className="flex-row gap-1 ai-center">
                        <h2> Tags </h2>
                        <DisplayForHead component={
                            <AddButtonFullText
                                id={categoryId}
                                setId={setAddModalIsOpen}
                                setUpdate={setAddModalIsOpen}
                            />
                        }/>
                    </div>
                    <TagList>
                        {categorySelected.tags.length > 0 &&
                        categorySelected.tags.map(t => (
                            <li
                                key={t.id + '/' + t.name}
                                onClick={() => setTagId(t.id)}>
                                <DisplayForHead
                                    component={<div className={"flex-row jtc-end"}>
                                        <EditButton
                                            data={t.id}
                                            setUpdate={updateTag}
                                        />
                                        <DeleteButton
                                            setOpenDeleteModal={setDeleteTagModalIsOpen}
                                        />
                                    </div>}
                                />
                                <TagCardStyled
                                    style={{backgroundColor: t.color}}
                                    className={"tags"}
                                >
                                    <p className={"tags"}>
                                        {t.name}
                                    </p>
                                </TagCardStyled>
                            </li>
                        ))
                        }
                        {categorySelected.tags.length === 0 &&
                        <p className={"fw-700"}> Pas de tags dans cette catégorie </p>
                        }
                    </TagList>
                    <div className={"border-grey"}/>
                </ContainerTagList>
            )
        }
    }

    const deleteRequest = async (id) => {
        await dispatch(deleteTagCategory(id))
        setCategoryId(0)
        await dispatch(loadAllTagCategories())
        setTimeout(() => setDeleteCategoryModalIsOpen(false), 500)
    }
    const deleteRequestTag = async (id) => {

        await dispatch(deleteTag(id))
        await dispatch(loadAllTagCategories())
        setTimeout(() => setDeleteTagModalIsOpen(false), 500)
    }
    const updateTagCategory = async (category_id) => {
        if (category_id !== 0) {
            await dispatch(loadOneTagCategory(category_id))
            setEditModalIsOpen(true)
        }
    }
    const updateTag = async (tag_id) => {
        if (tag_id !== 0) {
            await dispatch(loadTag(tag_id))
            setEditTagModalIsOpen(true)
        }
    }
    const displayModals = () => {
        if (addModalIsOpen && categoryId === 0) {
            // add category
            return (
                <AddTagModal
                    setModalIsOpen={setAddModalIsOpen}
                />
            )
        }
        if (addModalIsOpen && categoryId !== 0) {
            // add tag
            const category = categories.filter(tg => tg.id === categoryId)[0]
            return (
                <AddTagModal
                    isTag={true}
                    category={category}
                    setModalIsOpen={setAddModalIsOpen}
                />
            )
        }
        if (editModalIsOpen) {
            //edit category
            return (
                <AddTagModal
                    category={category}
                    isEditAction={true}
                    setModalIsOpen={setEditModalIsOpen}
                />
            )
        }
        if (editTagModalIsOpen) {
            // edit tag
            return (
                <AddTagModal
                    isTag={true}
                    isEditAction={true}
                    category={tag}
                    setModalIsOpen={setEditTagModalIsOpen}
                />
            )
        }
        if (deleteCategoryModalIsOpen) {
            return (
                <YesNoModal
                    name={"cette catégorie ?"}
                    setOpenModal={setDeleteCategoryModalIsOpen}
                    handleClickYesAction={deleteRequest}
                    id={categoryId}
                />
            )
        }
        if (deleteTagModalIsOpen) {
            return (
                <YesNoModal
                    name={"ce tag ?"}
                    setOpenModal={setDeleteTagModalIsOpen}
                    handleClickYesAction={deleteRequestTag}
                    id={tagId}
                />
            )
        }
    }

    const displayCategories = () => {
        if (category.length === 0) {
            return (
                <p className="fw-700"> Aucune catégorie créée</p>
            )
        } else {
            return (
                isLoading ?
                    <Loader/>
                    :
                    <CategoryList>
                        {categories.map(tc => (
                            <ToggleTagCard
                                key={tc.id}
                                setCategoryId={setCategoryId}
                                id={tc.id}
                                color={tc.color}
                                name={tc.name}
                                updateTagCategory={updateTagCategory}
                                setDeleteCategoryModalIsOpen={setDeleteCategoryModalIsOpen}
                                categoryId={categoryId}
                            >
                            </ToggleTagCard>
                        ))}
                    </CategoryList>
            )
        }
    }

    return (
        <Container ref={containerRef}
                   className={"container-tags"}
        >
            <h1> Tags </h1>
            <TitleSection>
                <h2> Catégories </h2>
                <DisplayForHead
                    component={
                        <AddButtonFullText
                            id={categoryId}
                            setId={setCategoryId}
                            setUpdate={setAddModalIsOpen}
                        />}
                />
            </TitleSection>
            {displayCategories()}
            {displaySubTag(categoryId)}
            {displayModals()}
        </Container>

    )
}

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1em;
  width: 100%;
  padding-left: 1em;

  h3, h4 {
    color: var(--color-white);
  }

`

const CategoryList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1em;
  padding-bottom: 2em;
  width: 100%;

  .header-card {
    display: flex;
    justify-content: flex-end;
    background-color: red;
  }
`

const TagList = styled.ul`
  display: flex;
  gap: 0.5em;
  flex-wrap: wrap;
  width: 100%;

  .header-card {
    justify-content: flex-end;
  }
`

const TitleSection = styled.div`
  display: flex;
  gap: 1em;
  align-items: center;
  width: 100%;
`

const ContainerTagList = styled.div`
  margin-top: 1em;
  display: flex;
  border: 1px solid rgba(166, 172, 181, 0.6);
  padding: 1em;
  border-radius: 10px;

  #category-tag-selected {
    font-size: 24px;
    align-self: center;
  }
`

export default TagsSectionSetting;